import { Link } from "react-router-dom";
import { CartContext } from "../contexts/CartContext"
import { useContext, useEffect } from "react"
import buildLink,{path} from "../urls";
import _axios from '../axios'
import Loader from "./Loader"
import { AccountContext } from "../contexts/AccountContext";
import CartSideModal from "./CartSideModal";


function TopCart() {
    const [state, dispatch] = useContext(CartContext)
    const [accountState] = useContext(AccountContext)
  
    useEffect(() => {
        dispatch({
            type: "loading",
            payload: true
        })
        _axios.get(buildLink("cartCount", undefined, window.innerWidth)).then((response) => {
            if (response.data.success) {
                
                dispatch({
                    type: "setProductsCount",
                    payload: response.data.data.nb_of_products
                })
                
                dispatch({
                    type: "loading",
                    payload: false
                })
            } else {
                dispatch({
                    type: "setProductsCount",
                    payload: 0
                })
                dispatch({
                    type: "loading",
                    payload: false
                })
            }
        })
    }, [dispatch])
  
    return (
        <>
        <CartSideModal />
  
        <Link 
            className={`font-semibold text-base flex items-center pl-1.5 pr-3 sm:pl-3 sm:pr-6 cursor-pointer hover:opacity-80 relative hidden md:flex`} 
            to={`${path}/cart`}
        >
            <span className="hidden xl:block lg:block text-white">Basket</span>
            <i className={`icon icon-basket ml-2 ${window.innerWidth < 650 ? 'text-dgreyBlack w-5' : 'text-white w-5'}`}></i>
            <span className={`w-5 h-5 bg-dblue flex text-white items-center justify-center rounded-full text-xs absolute right-0 sm:right-2 -top-1 border border-white ${window.innerWidth < 650 ? '-mr-0.5' : 'mr-1'}`}>
                <span>
                    {
                        state.loading ?
                            <Loader styles={'h-4 w-4 text-white'} />
                            :
                            <span style={{fonstSize:"10px"}}>{state.productsCount}</span>
                    }
                </span>
            </span>
        </Link>
        </>
    )
}
export default TopCart
